<template>
    <div class="cadre">
        <h3>Mouvements de stock par mois</h3>

        <canvas id="periode-stock-chart"></canvas>
    </div>
    <br/>
    <div class="cadre">
        <h3>Mouvements de stock par année</h3>

        <canvas id="annee-stock-chart"></canvas>
    </div>
</template>

<script>

import Axios from '@/services/axios.service';
import Chart from 'chart.js/auto';


export default {
    name: 'DashBoard',
    data() {
        return {
            mouvementStock: {},
        }
    },
    mounted() {
        this.getMouvementStock().then(() => {
            this.initChart(this.mouvementStock, 7, "periode-stock-chart"),
                this.initChart(this.mouvementStock, 4, "annee-stock-chart")
        })

    },
    methods: {
        getMouvementStock() {
            return Axios.get('/mouvementStock').then(res => {
                this.mouvementStock = res.data;
            })
        },
        initChart(mouvementStock, periodeSLice, idchart) {
            const tabPeriodeStock = {};
            mouvementStock
                .filter(item => item.date)
                .forEach((item) => {
                    const periode = item.date.slice(0, periodeSLice);
                    if (!tabPeriodeStock[periode]) {
                        tabPeriodeStock[periode] = { IN: 0, OUT: 0 };
                    }
                    tabPeriodeStock[periode][item.typeTraitement] += item.quantite;
                });

            const listePeriode = Object.keys(tabPeriodeStock);
            const listeEntre = listePeriode.map((periode) => tabPeriodeStock[periode].IN);
            const listeSortie = listePeriode.map((periode) => tabPeriodeStock[periode].OUT);

            this.createChart(idchart, listePeriode, listeEntre, listeSortie);

        },
        createChart(idchart, listPeriode, listeEntre, listeSortie) {

            const chart = document.getElementById(idchart).getContext("2d");
            new Chart(chart, {
                type: "bar",
                data: {
                    labels: listPeriode,
                    datasets: [
                        {
                            label: 'Entrées',
                            data: listeEntre,
                            backgroundColor: "rgba(75, 192, 192, 0.5)",
                            borderColor: "rgba(75, 192, 192, 1)",
                            borderWidth: 1,
                        },
                        {
                            label: 'Sorties',
                            data: listeSortie,
                            backgroundColor: "rgba(255, 99, 132, 0.5)",
                            borderColor: "rgba(255, 99, 132, 1)",
                            borderWidth: 1,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    scales: {
                        x: {
                            stacked: true, // Empile les barres sur l'axe X
                        },
                        y: {
                            beginAtZero: true, // Commence l'axe Y à zéro
                        },
                    },
                },
            });
        },
    },
}

</script>
<style>
 canvas{
    max-height: 250px;
 }
</style>
